import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Publication } from '../models/publication.model';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class PublicationService extends BaseService {
  baseUrl = 'public/publications';

  constructor(http: HttpClient) {
    super(http);
  }

  public getPublicationDetails(code: string): Observable<Publication> {
    return this.httpGet<Publication>(`${this.baseUrl}/${code}`);
  }
}
